import React from "react";
import "./GoalProgressDisplay.css";

interface GoalProgressDisplayProps {
  raised: number;
  goal: number;
}

const GoalProgressDisplay: React.FC<GoalProgressDisplayProps> = ({
  raised,
  goal,
}) => {
  const progressPercentage = Math.min(Math.round((raised / goal) * 100), 100);
  const remaining = Math.max(goal - raised, 0);
  return (
    <div className="participant-dashboard-goal-card">
      <div className="participant-dashboard-goal-header">
        <h3>Goal Progress</h3>

        <span className="participant-dashboard-goal-stats">
          {progressPercentage}% → ${remaining.toFixed(2)} remaining
        </span>
      </div>

      <div className="participant-dashboard-goal-progress-track">
        <div
          className="participant-dashboard-goal-progress-fill"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>

      <div className="participant-dashboard-goal-grid">
        <div className="participant-dashboard-goal-item">
          <span className="participant-dashboard-goal-label">RAISED</span>
          <span className="participant-dashboard-goal-value">
            ${raised.toFixed(2)}
          </span>
        </div>

        <div className="participant-dashboard-goal-item">
          <span className="participant-dashboard-goal-label">REMAINING</span>
          <span className="participant-dashboard-goal-value participant-dashboard-goal-value-remaining">
            ${remaining.toFixed(2)}
          </span>
        </div>

        <div className="participant-dashboard-goal-item">
          <span className="participant-dashboard-goal-label">GOAL</span>
          <span className="participant-dashboard-goal-value">
            ${goal.toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default GoalProgressDisplay;
